<template>
    <div class="carrito-wrapper" @mouseleave="toggleCarrito(false)">
        <b-button
            data-cy="carrito-icon"
            @mouseover="toggleCarrito(true)"
            @click="toggleCarrito(true)"
            class="carrito-icon position-relative"
        >
            <b-icon icon="cart" :variant="button_color || 'white'" font-scale="1.5"/>
            <span v-if="totalProductos > 0" class="badge badge-pill badge-danger position-absolute carrito-badge">
                {{ totalProductos }}
            </span>
        </b-button>

        <b-collapse v-model="mostrarCarrito" class="carrito-dropdown">
            <div class="dropdown-content p-3 pt-0">
                <TimerEntradasComponent 
                    v-if="carritoItems.length > 0"
                    pb="pb-2"
                    :secondsLeft="secondsLeft"
                />
                <h5 class="dropdown-header">{{ $t('carrito.mi_carrito') }}</h5>
                <div v-if="carritoItems.length === 0" class="text-center p-2">
                    <h4>{{ $t('carrito.no_hay_entradas') }}</h4>
                </div>
                <div v-else class="carrito-items">
                    <ul class="list-unstyled">
                        <li v-for="(item, index) in carritoItems" :key="index" class="mb-3">
                            <div class="evento-info">
                                <div>{{ item.evento }}</div>
                                <div>{{ item.fecha }}</div>
                            </div>
                            <ul class="list-unstyled mt-2 pl-3">
                                <li v-for="(subItem, subIndex) in item.items" :key="subIndex" class="d-flex justify-content-between align-items-start mb-2">
                                    <div class="d-flex flex-column">
                                        <span class="entrada-text">
                                            <strong v-if="subItem.entrada.descripcion">{{ $t('carrito.entrada') }}: </strong> {{ subItem.entrada.descripcion }}
                                            <span v-if="subItem.asiento" class="asiento-text">
                                                {{ (subItem.asiento.region_name ? subItem.asiento.region_name : '') + ' | ' + $t('carrito.fila') + ': ' + subItem.asiento.row + ' | ' + $t('carrito.asiento') + ': ' + subItem.asiento.seat }}
                                            </span>
                                            <span v-if="subItem.plaza" class="asiento-text">
                                                {{ (subItem.plaza.region_name ? subItem.plaza.region_name : '') + ' | ' + $t('carrito.fila') + ': ' + subItem.plaza.fila + ' | ' + $t('carrito.asiento') + ': ' + subItem.plaza.butaca }}
                                            </span>
                                        </span>
                                        <span class="text-muted">{{ $t('carrito.cantidad') }}: {{ subItem.units }}</span>
                                        <span class="text-muted">{{ $t('carrito.precio') }}: {{ $n(subItem.precio_unidad, 'currency') }}</span>
                                        <span v-if="subItem.units > 1" class="text-muted" style="font-size: 0.9rem;">
                                            (Precio por unidad: {{ subItem }} {{ subItem.precio_unidad }})
                                        </span>
                                    </div>
                                    <b-icon icon="trash" variant="dark" class="eliminar-icon mr-2" @click="eliminarProducto(subItem.id)" />
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <template v-if="carritoItems.length > 0">
                    <div class="total-info">
                        <div class="d-flex justify-content-between align-items-center">
                            <div><strong>{{ $t('carrito.numero_entradas') }}</strong></div>
                            <div>{{ totalProductos }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div><strong>{{ $t('carrito.gastos_gestion') }}</strong></div>
                            <div>{{ gastos | formatear_precio }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div><strong>{{ $t('carrito.total') }}</strong></div>
                            <div>{{ totalPrecio | formatear_precio }}</div>
                        </div>
                    </div>
                    <b-button data-cy="ver-carrito" variant="primary" block @click="irADetalleCarrito" :disabled="!carritoItems">{{ $t('carrito.ver_carrito') }}</b-button>
                </template>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    import TimerEntradasComponent from '@/components/common/carrito/TimerEntradasComponent.vue';
    export default {
        props: {
            carritoItems: Array,
            secondsLeft: Number,
            button_color: String
        },
        data() {
            return {
                mostrarCarrito: false,
                time: null,
                interval: null, 
            };
        },
        computed: {
            totalProductos() {
                if (this.carritoItems) {
                    return this.carritoItems.reduce((total, item) => {
                        return total + item.items.reduce((subTotal, subItem) => subTotal + subItem.units, 0);
                    }, 0);
                }
                return 0;
            },
            totalPrecio() {
                if (this.carritoItems) {
                    const totalCarrito = this.carritoItems.reduce((total, item) => {
                        return total + item.items.reduce((subTotal, subItem) => subTotal + (subItem.precio_unidad * subItem.units), 0);
                    }, 0);
                    return totalCarrito + this.gastos;
                }
                return 0;
            },
            gastos() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalGastosEvento = evento.items.reduce((suma, item) => {
                            if (!item.entrada.price_management_interno) {
                                return suma + item.entrada.price_management;
                            }
                        
                            return 0;
                        }, 0);
                        return total + totalGastosEvento;
                    }, 0);
                }

                return 0;
            }
        },
        methods: {
            toggleCarrito(mostrar) {
                this.mostrarCarrito = mostrar;
            },
            eliminarProducto(item_id) {
                this.$emit('eliminarProducto', item_id);
            },
            irADetalleCarrito() {
                this.mostrarCarrito = false
                this.$emit('irADetalleCarrito'); 
            },
        },
        components: { TimerEntradasComponent },
    };
</script>

<style scoped>
.carrito-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    z-index: 1050;
}

.carrito-icon {
    background-color: transparent;
    border: none;
    padding: 0;
    font-size: 1rem;
    color: white;
    cursor: pointer;
    position: relative;
}

.carrito-icon:hover,
.carrito-icon:focus,
.carrito-icon:active {
    outline: none;
    box-shadow: none;
    background-color: transparent !important;
    transform: scale(1.1);
    transition: transform 0.2s;
    box-shadow: none !important;
}

.carrito-badge {
    font-size: 0.75rem;
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: red;
    border-radius: 50%;
    padding: 0.25em 0.5em;
    color: white;
}

.carrito-dropdown {
    display: none;
    width: 400px;
    background-color: white;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    transition: all 0.3s ease-in-out;
    position: absolute;
    top: 100%;
    right: 0;
}

.carrito-wrapper:hover .carrito-dropdown,
.carrito-wrapper .carrito-dropdown.show {
    display: block;
}

.dropdown-content {
    background-color: white;
    padding: 10px;
    border-radius: 4px;
}

.dropdown-header {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 10px;
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 5px;
    text-align: center;
}

.total-info {
    margin-top: 20px;
    margin-right: 10px;
    margin-bottom: 15px;
    font-size: 1rem;
    font-weight: bold;
}

.list-unstyled {
    padding: 0;
    margin: 0;
}

.list-unstyled li {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 5px;
}

.list-unstyled li:last-child {
    border-bottom: none;
}

.eliminar-icon {
    cursor: pointer;
    font-size: 1.2rem;
    color: black;
}

.evento-text, .asiento-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.carrito-items {
    max-height: 350px;
    overflow-y: auto;
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .carrito-dropdown {
        width: 85vw;
        right: -45%;
    }

    .evento-text, .asiento-text {
        font-size: 0.85rem;
    }
}

.b-button {
    box-shadow: none !important;
}

.b-button:hover,
.b-button:focus {
    outline: none !important;
    box-shadow: none !important;
}

.entradas-disponibles {
    height: 50px;
    background-color: #032550;
    color: white;
    padding-top: 12px;
}

::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}

</style>